import React from "react";
import Helmet from "react-helmet";

const HelmetWithOneTrust = () => (
    <Helmet
      script={[
        {
          type: "text/javascript",
          src: `https://cdn.cookielaw.org/consent/4e799744-60a5-4e9f-a40a-21b3ba8a695a/OtAutoBlock.js`
        },
        {
          type: "text/javascript",
          innerHTML: `function OptanonWrapper() { }`
        },
      ]}
    >
      <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" type="text/javascript" charset="UTF-8"
        data-domain-script="4e799744-60a5-4e9f-a40a-21b3ba8a695a"></script>
    </Helmet>
  );

  export default HelmetWithOneTrust;